import comp from "./PortfolioInfoTooltip";
export default comp;
